/**
 * Human-readable 3-word kebab-case room codes (e.g. "silver-fox-delta").
 * Pure functions — no module-level state, no logging.
 *
 * @module features/p2p-chat/lib/roomCode
 */

import { generateSlug } from 'random-word-slugs';

const ROOM_CODE_REGEX = /^[a-z]+-[a-z]+-[a-z]+$/;
const MAX_LENGTH = 60;

/** Generate a fresh 3-word kebab-case code. */
export function generateRoomCode(): string {
  return generateSlug(3, { format: 'kebab' }).toLowerCase();
}

/** Strict format check — server uses the same regex (Part 2 §6). */
export function isValidRoomCode(code: string): boolean {
  return (
    typeof code === 'string' &&
    code.length > 0 &&
    code.length <= MAX_LENGTH &&
    ROOM_CODE_REGEX.test(code)
  );
}

/** Trim and lowercase user input before validation. */
export function normalizeRoomCode(input: string): string {
  return typeof input === 'string' ? input.trim().toLowerCase() : '';
}
